import { faCreditCard, faMoneyBillWave, faUniversity } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Начинът на плащане като иконка вместо текст.
 *
 * Иконките ги имаше първо в таб "Оборот", в друг вид: банката беше кредитна карта, а картата - телефон,
 * защото плащането с карта минава през SoftPOS на телефона на дистрибутора. Сега всяка показва това,
 * което значи, и всички са в един цвят - различаването е работа на формата, не на цвета, който тук не
 * носи собствен смисъл. Изнесени са в общ компонент, за да не се разминат екраните, когато някой ги пипне.
 *
 * Названието остава в title, тоест текстът е на един задържан курсор разстояние - иконка без обяснение
 * се чете само от този, който вече знае какво значи.
 *
 * Стойността идва ту с малки, ту с главни букви: InvoicingVM я пише с toLowerCase в проекцията за
 * списъка, но с name() в конструктора от ентитет. Затова се снишава тук, а не при викащия.
 */
export const PaymentMethodIcon = ({ paymentMethod }: { paymentMethod?: string }) => {
    const { t } = useTranslation('translation', { keyPrefix: 'invoice' });

    if (!paymentMethod) return null;

    const method = paymentMethod.toLowerCase();

    return (
        <FontAwesomeIcon
            title={t(method)}
            color='green'
            size='lg'
            icon={method === 'bank' ? faUniversity : method === 'card' ? faCreditCard : faMoneyBillWave}
        />
    );
};
